// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__AU2qI","heading":"Modal_heading__AnWrj","subHeading":"Modal_subHeading__vKbsH"};